export const CSS = {
  container: "container",
  heading: "heading",
  description: "description",
  anchor: "anchor",
  image: "image",
  standalone: "standalone",
  icon: "icon",
};
